export default "__VITE_ASSET__ZvooiVyF__"